import { StoreState } from '@/redux/types';
import { getCore } from './getCore';

export function getContext(state: StoreState) {
  return getCore(state).context;
}
